module.exports = __webpack_public_path__ + "img/gj1.a7b36334.png";